// Generated by scripts/mdi/import-questionnaires.mjs from MDI "1. Semaglutide + B6 Refill 09.17.26" (999fd97e-6aad-46a5-a897-d9a1ce8532ea). Re-run instead of editing.
import { QuestionAnswerMap } from '@care-portals/api-interfaces';

const mdiSemaglutideB6RefillQuestions = [
  {
    field: 'mdiSemaglutideB6Refill_state',
    label: 'Which state do you live in?',
    type: 'select',
    extras: { sendToBeluga: false, sendToMdi: false, mdiRouting: true },
    answer: {
      type: 'single_select',
      options: [
        { key: 'la', value: 'Louisiana' },
        { key: 'ms', value: 'Mississippi' },
        { key: 'other', value: 'Another state' }
      ]
    }
  },
  {
    field: 'mdiSemaglutideB6Refill_considerTreatmentGlp1AppropriateReasons',
    label:
      'We will consider you for treatment with a GLP1 if it is appropriate. Which reasons are you consulting for?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'microdosing_for_general_health_benefits',
          value: 'Microdosing for general health benefits'
        },
        { key: 'longevity', value: 'Longevity' },
        { key: 'anti_inflammatory', value: 'Anti-inflammatory' },
        { key: 'support_healthy_weight', value: 'Support healthy weight' },
        { key: 'cardiovascular_benefit', value: 'Cardiovascular benefit' },
        { key: 'neurocognitive_benefit', value: 'Neurocognitive benefit' },
        {
          key: 'other_please_specify',
          value: 'Other (please specify)',
          answer: {
            type: 'text',
            name: 'other_please_specify_details',
            placeholder: 'Please specify'
          }
        }
      ]
    },
    extras: { mdiQuestionId: 'bcdcd536-0a54-468c-ba80-97cf7fd270f8' }
  },
  {
    field: 'mdiSemaglutideB6Refill_overPast4WeeksApproximately',
    label:
      'Over the past 4 weeks, approximately how many pounds have you lost?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'o_0_3_pounds', value: '0-3 pounds' },
        { key: 'o_4_6_pounds', value: '4-6 pounds' },
        { key: 'o_7_12_pounds', value: '7-12 pounds' },
        { key: 'o_13_20_pounds', value: '13-20 pounds' },
        { key: 'more_than_20_pounds', value: 'More than 20 pounds' },
        { key: 'im_gaining_weight', value: "I'm gaining weight" }
      ]
    },
    extras: { mdiQuestionId: 'a4353b50-8a46-44a4-87ac-4b54d0efd0a3' }
  },
  {
    field: 'mdiSemaglutideB6Refill_stillGainingWeight',
    label: 'Still gaining weight?',
    type: 'select',
    educationalSlide:
      'It is very common for people who are just starting the medication to have little to no weight loss for the first month.\nWhat other things have you done other than take medication?',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'i_have_seen_a_dietician', value: 'I have seen a dietician' },
        {
          key: 'decreased_my_calorie_intake',
          value: 'Decreased my calorie intake'
        },
        {
          key: 'started_an_exercise_program',
          value: 'Started an exercise program'
        },
        {
          key: 'attempted_to_decrease_stress_from_my_lif',
          value:
            'Attempted to decrease stress from my life which can cause increase in cortisol levels'
        },
        { key: 'none_of_the_above', value: 'None of the above' }
      ]
    },
    extras: { mdiQuestionId: 'c54b24da-b0da-4efa-9948-15e14771d698' }
  },
  {
    field: 'mdiSemaglutideB6Refill_youreHavingSignificantAmountWeight',
    label: "You're having significant amount of weight loss:",
    type: 'info',
    subLabel:
      'Please describe in detail other things you are doing to lose weight.  Please detail extensively what your diet has been within the last 72 hours. Be very precise.',
    answer: {
      type: 'text',
      name: 'mdiSemaglutideB6Refill_youreHavingSignificantAmountWeight',
      rows: 4,
      placeholder:
        'Ex: Eating very few calories. Perhaps _____ calories a day. Over the last 72 hours I have eaten.....'
    },
    extras: { mdiQuestionId: 'd68af609-2e89-4d9e-8948-90d48339c14f' }
  },
  {
    field: 'mdiSemaglutideB6Refill_havingFoodCravings',
    label: 'Are you having food cravings?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'not_really', value: 'Not really' },
        { key: 'sometimes', value: 'Sometimes' },
        { key: 'quite_often', value: 'Quite often' }
      ]
    },
    extras: { mdiQuestionId: '4217eb40-e8f6-481c-8148-07ba807b438a' }
  },
  {
    field: 'mdiSemaglutideB6Refill_havingAppetiteSuppression',
    label: 'Are you having appetite suppression?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes_just_where_i_want_to_be',
          value: 'Yes, just where I want to be'
        },
        {
          key: 'somewhat_decreased_appetite',
          value: 'Somewhat decreased appetite'
        },
        {
          key: 'way_too_much_appetite_suppression_i_cant',
          value: "Way too much appetite suppression! I can't eat anything"
        },
        { key: 'im_always_hungry', value: "I'm always hungry!" }
      ]
    },
    extras: { mdiQuestionId: 'e5cd8b9e-3e3c-4f22-a0f5-e9f22c1f2646' }
  },
  {
    field: 'mdiSemaglutideB6Refill_newChangesAdditionsMedicalHistory',
    label: 'Do you have any new changes/additions to your medical history?',
    type: 'select',
    educationalSlide:
      'This includes:\n• New medications\n• Allergies\n• ER Visits or hospitalizations\n• Surgeries',
    answer: {
      type: 'single_select',
      options: [
        { key: 'no', value: 'No' },
        { key: 'yes_i_do', value: 'Yes, I do' }
      ]
    },
    extras: { mdiQuestionId: '44fc8865-2d2b-47d4-abf5-563c82ef8cf7' }
  },
  {
    field: 'mdiSemaglutideB6Refill_tellDoctorAboutNewMedical',
    label: 'Please tell the doctor about any new medical history:',
    type: 'info',
    subLabel:
      'This includes:\n• Medications\n• Surgeries\n• ER visits or hospitalizations',
    answer: {
      type: 'text',
      name: 'mdiSemaglutideB6Refill_tellDoctorAboutNewMedical',
      rows: 4
    },
    extras: { mdiQuestionId: '823ea815-af31-499b-a5e6-48a6db654d4f' }
  },
  {
    field: 'mdiSemaglutideB6Refill_havingProblemsCommonSideEffects',
    label: 'Are you having problems with common side effects?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'not_at_this_time', value: 'Not at this time' },
        {
          key: 'tell_me_more_about_nausea',
          value: 'Tell me more about NAUSEA'
        },
        {
          key: 'tell_me_more_about_constipation',
          value: 'Tell me more about CONSTIPATION'
        },
        {
          key: 'tell_me_more_about_indigestion_reflux',
          value: 'Tell me more about INDIGESTION/REFLUX'
        }
      ]
    },
    extras: { mdiQuestionId: '6ddc8aee-e5c2-46b0-82f2-b4c1427c2500' }
  },
  {
    field: 'mdiSemaglutideB6Refill_majorSideEffectsConcernedAbout',
    label: 'Any major side effects which you are concerned about?',
    type: 'select',
    educationalSlide:
      'It is common to have nausea, mild constipation or loose stools with GLP-1 medications',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'having_side_effects_but_i_can_handle_the',
          value: 'Having side effects, but I can handle them'
        },
        { key: 'significant_vomiting', value: 'Significant vomiting' },
        {
          key: 'abdominal_pain_that_concerns_me',
          value: 'Abdominal pain that concerns me'
        },
        {
          key: 'dizziness_that_concerns_me',
          value: 'Dizziness that concerns me'
        },
        { key: 'chest_pain', value: 'Chest pain' },
        { key: 'fevers', value: 'Fevers' },
        { key: 'swelling_in_my_neck', value: 'Swelling in my neck' },
        { key: 'other', value: 'Other' },
        { key: 'none_of_the_above', value: 'NONE of the above' }
      ]
    },
    extras: { mdiQuestionId: '78cd5fe9-f4db-4fbd-8e02-b24c04563fdf' }
  },
  {
    field: 'mdiSemaglutideB6Refill_makeSureLetDoctorPcp',
    label: 'Please make sure to let your doctor and your PCP know if:',
    type: 'select',
    educationalSlide:
      '• Your symptoms persist\n• Your symptoms worsen\n• Your symptoms concern you',
    answer: {
      type: 'single_select',
      options: [
        { key: 'i_acknowledge_the_above', value: 'I acknowledge the above' }
      ]
    },
    extras: { mdiQuestionId: 'b684a220-099a-4405-9a3e-839ace91bf24' }
  },
  {
    field: 'mdiSemaglutideB6Refill_vomitingWhileTakingGlp1',
    label: 'Vomiting while taking a GLP-1 medication',
    type: 'select',
    educationalSlide:
      '• While occasional vomiting can be normal with taking this medication, please be aware that significant and continued vomiting will lead to electrolyte problems and kidney failure.\n• It is possible that you could be having something other than a medication side effect therefore we recommend that you go to your nearest urgent care center if you are not able to see your primary care doctor today.',
    answer: {
      type: 'single_select',
      options: [
        { key: 'i_acknowledge_the_above', value: 'I acknowledge the above' }
      ]
    },
    extras: { mdiQuestionId: '94520dae-1db0-4ab3-8ddc-c79ba9b18098' }
  },
  {
    field: 'mdiSemaglutideB6Refill_abdominalPainWhileTakingGlp',
    label: 'Abdominal pain while taking a GLP-1 medication',
    type: 'select',
    educationalSlide:
      'While mild and intermittent symptoms may be due to constipation or a medication side effect\n• It is possible that you could be having a serious medical problem.  Often abdominal pain medical visits require laboratory tests, and possibly an X-ray, ultrasound, or CT Scan, therefore we recommend that you go to your nearest urgent care center if you are not able to see your primary care doctor today.',
    answer: {
      type: 'single_select',
      options: [
        { key: 'i_acknowledge_the_above', value: 'I acknowledge the above' }
      ]
    },
    extras: { mdiQuestionId: 'fcc1924a-0066-4285-a765-aba78f6a52f1' }
  },
  {
    field: 'mdiSemaglutideB6Refill_dizzinessWhileTakingGlp1',
    label: 'Dizziness while taking a GLP-1 medication:',
    type: 'select',
    educationalSlide:
      'It is impossible for your doctor to diagnose you over telemedicine if you are feeling dizzy.\n• It is possible that you could be having a serious medical problem.  You will require an in-person exam, vital signs, and possibly laboratory tests, EKG, and radiographic imaging. Therefore, we recommend that you go to your nearest urgent care center if you are not able to see your primary care doctor today.',
    answer: {
      type: 'single_select',
      options: [
        { key: 'i_acknowledge_the_above', value: 'I acknowledge the above' }
      ]
    },
    extras: { mdiQuestionId: '8d0d1849-e94c-4a93-963d-c15e300c9807' }
  },
  {
    field: 'mdiSemaglutideB6Refill_chestPainWhileTakingGlp',
    label: 'Chest pain while taking a GLP-1 medication:',
    type: 'select',
    educationalSlide:
      "Chest pain is never 'normal' and should always be discussed with a doctor in person:\n• It is possible that you could be having a serious medical problem. &#160;\n• We recommend that you go to your nearest urgent care center or Emergency Room if you are not able to see your primary care doctor today.",
    answer: {
      type: 'single_select',
      options: [
        { key: 'i_acknowledge_the_above', value: 'I acknowledge the above' }
      ]
    },
    extras: { mdiQuestionId: '1c914f2e-f3a0-4172-834d-ec43e7f59921' }
  },
  {
    field: 'mdiSemaglutideB6Refill_feverWhileTakingGlp1',
    label: 'Fever while taking a GLP-1 medication:',
    type: 'select',
    educationalSlide:
      'Fevers are not common while taking a GLP-1 medication.\n• It is possible that you could be having a serious medical problem.&#160; therefore we recommend that you go to your nearest urgent care center if you are not able to see your primary care doctor today.',
    answer: {
      type: 'single_select',
      options: [
        { key: 'i_acknowledge_the_above', value: 'I acknowledge the above' }
      ]
    },
    extras: { mdiQuestionId: '6309d316-5a4b-4280-bc48-566f751641a4' }
  },
  {
    field: 'mdiSemaglutideB6Refill_swellingNeckWhileTakingGlp',
    label: 'Swelling in the neck while taking any GLP-1 medication:',
    type: 'select',
    educationalSlide:
      'Because of the unknown risk of certain types of thyroid cancers associated with taking any GLP-1 medication:\n• Stop taking semaglutide (any GLP-1 medication).\n• Contact your local PCP for an in-person examination today',
    answer: {
      type: 'single_select',
      options: [
        { key: 'i_acknowledge_the_above', value: 'I acknowledge the above' }
      ]
    },
    extras: { mdiQuestionId: '13ea98b7-1055-4433-b095-bb1b27941d8e' }
  },
  {
    field: 'mdiSemaglutideB6Refill_tellDoctorAboutSymptomsExperiencing',
    label:
      'Please tell the doctor all about the symptoms you are experiencing:',
    type: 'info',
    subLabel:
      'Include the following:\n• When did it start?\n• How severe is it?\n• Where in your body are the symptoms?\n• Have you had this before?\n• Have you been taking any medication for it?\n• Have you seen a doctor about this already?',
    answer: {
      type: 'text',
      name: 'mdiSemaglutideB6Refill_tellDoctorAboutSymptomsExperiencing',
      rows: 4
    },
    extras: { mdiQuestionId: '92715521-4455-45d2-b1e7-d86ea215a9f5' }
  },
  {
    field: 'mdiSemaglutideB6Refill_nauseaMostCommonSideEffect',
    label:
      "Nausea is the MOST common side effect of taking a GLP-1 medication. Make sure you're doing all the following:",
    type: 'select',
    educationalSlide:
      '• Eat bland, low-fat foods, like crackers, toast, and rice\n• Eat foods that contain water, like soups and gelatin\n• Avoid fried, greasy, or sweet foods\n• Eat more slowly\n• Avoid laying down after you eat\n• Drink clear or ice-cold drinks',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'ive_read_the_above_and_understand',
          value: "I've read the above and understand"
        },
        {
          key: 'if_i_qualifiy_id_like_a_medication_like',
          value:
            "If I qualifiy, I'd like a medication like ondansetron (Zofran) to help with the nausea. I understand this will be sent and paid for at my local pharmacy, cost is variable."
        },
        {
          key: 'ive_tried_ondansetron_without_success_is',
          value:
            "I've tried ondansetron without success. Is there anything else I can take?"
        }
      ]
    },
    extras: { mdiQuestionId: '3a78f257-d472-4f96-9bd1-da5e98f29620' }
  },
  {
    field: 'mdiSemaglutideB6Refill_constipation',
    label: 'Constipation',
    type: 'select',
    educationalSlide:
      "Constipation is the second most common side effect. Don't just try one and give up,   Instead add onto the one above.\n1. Prunes\n2. Caffeine (within reason)\n3. Water water water\n4. Glycerine rectal suppositories\n5. Over the counter medications (ex: Miralax)",
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'ive_read_and_understand_the_above',
          value: "I've read and understand the above"
        }
      ]
    },
    extras: { mdiQuestionId: '038e6fcd-3a47-4227-8dda-6fd14965e89e' }
  },
  {
    field: 'mdiSemaglutideB6Refill_heartburn',
    label: 'Heartburn',
    type: 'select',
    educationalSlide:
      'Heartburn/"Reflux" can be very common while taking a GLP-1 medication.\nIf you do not know what heartburn is, or think something else may be wrong, please go to your PCP or nearest urgent care.\n1. Eat smaller meals–try splitting your 3 daily meals into 4 or more smaller ones.\n2. Stop eating when you feel full.\n3. Avoid all alcohol and caffeine.\n4. Do not lay down after eating.\n5. Use over-the-counter medication such as famotidine, or aluminum/magnesium hydroxide/simethicone.',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'i_have_read_and_understand_the_above',
          value: 'I have read and understand the above'
        },
        {
          key: 'im_already_taking_over_the_counter_heart',
          value:
            "I'm already taking over the counter heart burn medication, are there other options?"
        }
      ]
    },
    extras: { mdiQuestionId: '94a2ebd2-735b-472b-99dd-b51c45a8d99a' }
  },
  {
    field: 'mdiSemaglutideB6Refill_readInformationAboutPersonalizedTreatment',
    label:
      'Please read the following information about your personalized treatment and you can proceed if you agree.',
    type: 'select',
    educationalSlide:
      'Do you agree that you would like your doctor to continue your personalized compounded-GLP1 treatment plan and make any necessary adjustments to your current dose? Continuous GLP-1  treatment can sometimes lead to nausea over time. Would you like your refill to include a targeted additive that will help limit this side effect, making it easier to stay on track with your progress? Do you also agree that you would like your doctor to maintain dosing flexibility so your treatment continues to fit your personal needs?',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes_i_have_read_the_above_and_agree_that',
          value:
            'Yes, I have read the above and agree that I would like my doctor to create a personalized treatment plan for me to reduce the possibility of any side effects and help me adhere to my treatment plan.'
        }
      ]
    },
    extras: { mdiQuestionId: 'a0083ed0-d615-4900-82c2-984e0a92271a' }
  },
  {
    field:
      'mdiSemaglutideB6Refill_wereDiscontinueCompoundedTreatmentSignificantly',
    label:
      'If I were to discontinue my compounded treatment it would significantly impact my health because it would cause (check all that apply):',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'significant_weight_gain', value: 'Significant weight gain' },
        { key: 'depression', value: 'Depression' },
        { key: 'anxiety', value: 'Anxiety' },
        {
          key: 'increase_in_blood_pressure',
          value: 'Increase in blood pressure'
        },
        { key: 'increase_in_blood_sugar', value: 'Increase in blood sugar' },
        { key: 'increase_in_cholesterol', value: 'Increase in cholesterol' },
        {
          key: 'worsening_of_medical_conditions_i_have',
          value: 'Worsening of medical conditions I have'
        },
        {
          key: 'other_free_text_box',
          value: 'Other (free text box)',
          answer: {
            type: 'text',
            name: 'other_free_text_box_details',
            placeholder: 'Please specify'
          }
        }
      ]
    },
    extras: { mdiQuestionId: '4127ddd9-d473-45e6-b233-551142e4a2a0' }
  },
  {
    field: 'mdiSemaglutideB6Refill_nextPrescriptionThinkShould',
    label: 'With your next prescription, do you think you should be:',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'increase', value: 'Increase' },
        { key: 'decrease', value: 'Decrease' },
        { key: 'stay_at_the_same_dose', value: 'Stay at the same dose' }
      ]
    },
    extras: { mdiQuestionId: '8c1eeb5f-52a4-4d41-8bc8-741ddf672f5b' }
  },
  {
    field: 'mdiSemaglutideB6Refill_importantClickAttachedLinkReview',
    label:
      'IMPORTANT: please click the attached link to review the consent for your GLP1 treatment plan. By typing your full legal name into the signature field you are attesting that you have read and understand this consent in its entirety.',
    type: 'info',
    subLabel:
      'Please click this link to view the GLP1 consent (https://drive.google.com/file/d/1LRpyB2kfqesrrWWPEX2UvsP6639nQrID/view?usp=sharing)\n\nPlease type your full legal name below to proceed.',
    answer: {
      type: 'text',
      name: 'mdiSemaglutideB6Refill_importantClickAttachedLinkReview',
      placeholder: 'Type your full legal name to proceed'
    },
    extras: { mdiQuestionId: '87671162-9008-4b65-94d6-1823ec4fe5d8' }
  },
  {
    field: 'mdiSemaglutideB6Refill_messageDoctorGiveUpdateFeel',
    label: 'Message your doctor!  Please give an update and feel free to:',
    type: 'info',
    subLabel:
      '• Ask any questions you have&#160;&#160;\n• List any medical problem you have which were not discussed above&#160; &#160; &#160; &#160; &#160;&#160;\n• Include anything else you would like the doctor to know.',
    answer: {
      type: 'text',
      name: 'mdiSemaglutideB6Refill_messageDoctorGiveUpdateFeel',
      rows: 4,
      placeholder:
        "Example: Everything is going well so far and I'm happy with my treatment."
    },
    extras: { mdiQuestionId: '0c7fc073-a7f0-468d-84e3-132e2fd7b215' }
  },
  {
    field: 'mdiSemaglutideB6Refill_complete',
    label:
      'Thank you for completing this questionnaire, please select "Finish" to submit',
    type: 'info',
    isLast: true,
    answer: {},
    extras: { sendToBeluga: false, sendToMdi: false }
  }
] as const;

export type mdiSemaglutideB6RefillAnswerField = Partial<
  QuestionAnswerMap<typeof mdiSemaglutideB6RefillQuestions>
>;

export default mdiSemaglutideB6RefillQuestions;
